module.exports = __webpack_public_path__ + "media/images/frontend/list_view-051837e58e740c30e277161d80800862.svg";